<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:false,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 志信学习形式查询
     */
    import tableMixin from '@/mixins/table.js';
	import {EducationType} from '@/plugins/enums.js';
    export default {
        mixins: [tableMixin],
        name:"StudyTypeList",
        components: {

        },
        data:function(){
            return {
                // 查询条件
                query:{
                },
                columns: [
                    {
                        field: 'id',
                        title: '学习形式代码'
                    },
                    {
                        field: 'mc',
                        title: '学习形式名称'
                    },
                    {
                        field: 'xllx',
                        title: '学历类型',
                        formatter: (value) => {
							let arr = [];
							if(value){
								arr = EducationType.filter(x=>x.value==value);
							}
                            return arr && arr.length>0 ? arr[0].text : '';
                        }
                    }
                ]
            }
        },
        mounted(){
            this.load();
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'基础数据'},{name:'基础信息查询'},{name:'学习形式查询'}]);
        },
        methods: {
            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/inf/xxxs/cx',this.query).then(res=>{
                    let data = res.data;
                    //table加载返回的数据
                    this.$refs.table.load(data);
                });
            }
        }

    }
</script>
<style scoped>

</style>